import { useEffect, useState } from "react";
import React from "react";
import { Link } from "react-router-dom";
import Api from "../../Api/Api";
import { username } from "../../API";
import "./continueTowatch.css"; // Ensure the correct CSS file is imported

const ContiToWatch = () => {
  const [conti, setConti] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true); // Start loading
        const { watchhistory } = await Api.getContinueToWatch(username);
        console.log("watchhistory", watchhistory);
        setConti(watchhistory);
      } catch (error) {
        console.error("Error fetching continue-to-watch data:", error);
      } finally {
        setLoading(false); // End loading
      }
    };
    getData();
  }, []);

  return (
    <div className="continueTowatch-home">
      {loading ? (
        <div className="loading-indicator">
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>) : conti?.length !== 0 ? (
          <>
            <h5 className="continueTowatch-title">Continue Watching</h5>

            {/* Cards Slider */}
            <div className="continueTowatch-slider">
              {conti.map((movie, index) => (
                <Link
                  to={`/view/continue/${movie.vid?._id}/${movie?.time}/${movie.vid?.video.split("/videos/")[1]}`}
                  className="movie-link"
                  key={index}
                >
                  <div className="movie-card">
                    <img
                      src={movie.vid?.thumbnail}
                      alt={movie.vid?.title}
                      className="movie-thumbnail"
                    />
                    <div className="movie-info">
                      <span className="movie-title">{movie?.vid?.title}</span>
                      {/* <span className="movie-languages">
                        <small>
                          ({movie.vid?.Languages?.slice(0, 15) || "English"}
                          {movie.vid?.Languages?.length > 15 && `...`})
                        </small>
                      </span> */}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </>
        ) : <></>}
    </div>
  );
};

export default ContiToWatch;
